import { useEffect, useState, useContext } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header from "../Header";
import Footer from "../Footer";

import { AuthContext } from '../../context/AuthContext';
import { useForm } from 'react-hook-form';

import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { firebaseAuth } from '../../firebase';

import { ReactComponent as HideTextSvg } from '../../assets/hide_text.svg';
import { ReactComponent as ShowTextSvg } from '../../assets/show_text.svg';

export default function ResetPassword () {

	const { currentUser, user } = useContext(AuthContext);

	const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({

    });

	const [isShowPassword, setShowPassword] = useState(false);
    const togglePassword = () => {
        setShowPassword(!isShowPassword);
    };

	const [isShowNewPassword, setShowNewPassword] = useState(false);
    const toggleNewPassword = () => {
        setShowNewPassword(!isShowNewPassword);
    };

	const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

	const Save = async (data) => {
		console.log(data);

		if (data['new_password'] != data['repeat_new_password']){
			setMessage('Passwords do not match');
			return;
		}
		const oldPassword = data['password'];
		let email = firebaseAuth.currentUser.email;

		console.log(email);
		console.log(currentUser);

		const auth = getAuth();
		const credential = EmailAuthProvider.credential(
			auth.currentUser.email,
			oldPassword
		)
		const result = await reauthenticateWithCredential(
			auth.currentUser,
			credential
		).then(() => {
			const newPassword = data['new_password']
			updatePassword(auth.currentUser, newPassword).then(() => {
				console.log('Succeed');
				setMessage('Succeed');
			})
			.catch((error) => {
				setMessage('Failed to change password');
			})
		})
		.catch((error) => {
			setMessage('The current password is incorrect');
		})

	}

	return (
		<div className="page page_password">

            <Header />

            {user['email'] ?

                <main>
                    <div className="content">

                        <ul className="breadcrumbs">
                            <li>
                                <NavLink to="/">Home</NavLink>
                            </li>
                            <li>
                                <NavLink to="/profile">Profile</NavLink>
                            </li>
                            <li>
                                <span>Change Password</span>
                            </li>
                        </ul>

                        <div className="page__title">
                            <h1>Change Password</h1>
                        </div>

                        <div className="columns">
                            <div className="column">
                                <section className="dashed-border profile">

									<div className="block">
										<div className="title">Password</div>
										<label className="password">
											<input
											{...register("password", {
												required: "Please enter your password",
												pattern: {
													value:
														/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
													message: "Invalid password",
												},
											})}
											placeholder="Password"
											type={isShowPassword ? 'text' : 'password'}
											/>
											<div className="error">{errors.password?.message}</div>
											<HideTextSvg
												className={isShowPassword ? null : 'hide'}
												onClick={togglePassword}
											/>
											<ShowTextSvg
												className={isShowPassword ? 'hide': null}
												onClick={togglePassword}
											/>
										</label>
									</div>
									<div className="block">
										<div className="title">New password</div>
										<label className="password">
											<input
											{...register("new_password", {
												required: "Please enter new password",
												pattern: {
													value:
														/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
													message: "Invalid password",
												},
											})}
											placeholder="New password"
											type={isShowNewPassword ? 'text' : 'password'}
											/>
											<div className="error">{errors.new_password?.message}</div>
											<HideTextSvg
												className={isShowNewPassword ? null : 'hide'}
												onClick={toggleNewPassword}
											/>
											<ShowTextSvg
												className={isShowNewPassword ? 'hide': null}
												onClick={toggleNewPassword}
											/>
										</label>
									</div>
									<div className="block">
										<div className="title">Repeat new password</div>
										<label className="password">
											<input
											{...register("repeat_new_password", {
												required: "Please repeat new password",
												pattern: {
													value:
														/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
													message: "Invalid password",
												},
											})}
											placeholder="Repeat new password"
											type={isShowNewPassword ? 'text' : 'password'}
											/>
											<div className="error">{errors.repeat_new_password?.message}</div>
											<HideTextSvg
												className={isShowNewPassword ? null : 'hide'}
												onClick={toggleNewPassword}
											/>
											<ShowTextSvg
												className={isShowNewPassword ? 'hide': null}
												onClick={toggleNewPassword}
											/>
										</label>
									</div>

									<div className="buttons">
										<button className="button_publish button" onClick={handleSubmit(Save)}>
											Save
										</button>
									</div>

									<div className="error">{message}</div>

                                </section>
                            </div>

                        </div>


                    </div>
                </main>

                :

                <>
					...Загрузка...
                </>
            }

            <Footer />

        </div>

    )

}
